// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cms-permission-container {
  font-family: Arial, sans-serif;
  padding: 10px;
}

.category-item {
  padding: 10px 0px;
  background-color: #F4F6FD;
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 10px;
}

.category-header {
  display: flex !important;
  align-items: center !important;
  cursor: pointer;
  margin-bottom: 15px !important;
}

.subcategory-header {
  margin-bottom: 15px !important;
  border-top: 1px solid #C8C8C8;
  padding-top: 10px;
}

.category-header,
.subcategory-header {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.permission-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 10px;
  margin-left: 20px;
  margin-top: 10px;
}

.permission-item {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.33% - 20px);
  margin: 5px 0 !important;
  box-sizing: border-box;
  align-self: flex-start;
  display: flex;
  align-items: center;
}

.permission-flex::after {
  content: "";
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.33% - 20px);
}

.collapse-arrow {
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
}

.nested-permission-group {
  margin-top: 20px;
  background: #F4F6FD;
  padding: 22px;
}

.nested-permission-group-title label {
  position: inherit !important;
  color: black;
  font-size: 16px;
  font-weight: 700;
  font-size: 18px;
  margin-left: 5px;
  background: transparent;
}

.cms-permission-label {
  position: inherit !important;
  margin-left: 5px;
  color: black;
  background-color: transparent;
  font-weight: 600;
  font-size: 16px;
}

.subcategory-label,
.category-label {
  font-weight: bold;
  font-size: 16px;
}

.subcategory-container {
  margin-left: 20px;
  margin-top: 10px;
}

.subcategory-item {
  margin-bottom: 10px;
}

@media screen and (max-width: 768px) {
  .nested-permission-group {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/CMSPermission/CmsPermission.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,8BAAA;EACA,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,8BAAA;EACA,6BAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EAAA,cAAA;EAAA,+BAAA;EACA,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EAAA,cAAA;EAAA,+BAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,4BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF","sourcesContent":[".cms-permission-container {\n  font-family: Arial, sans-serif;\n  padding: 10px;\n}\n\n.category-item {\n  padding: 10px 0px;\n  background-color: #F4F6FD;\n  margin-bottom: 12px;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.category-header {\n  display: flex !important;\n  align-items: center !important;\n  cursor: pointer;\n  margin-bottom: 15px !important;\n}\n\n.subcategory-header {\n  margin-bottom: 15px !important;\n  border-top: 1px solid #C8C8C8;\n  padding-top: 10px;\n}\n\n.category-header,\n.subcategory-header {\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n}\n\n.permission-flex {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-left: 20px;\n  margin-top: 10px;\n}\n\n.permission-item {\n  flex: 1 1 calc(33.33% - 20px);\n  margin: 5px 0 !important;\n  box-sizing: border-box;\n  align-self: flex-start;\n  display: flex;\n  align-items: center;\n}\n\n.permission-flex::after {\n  content: '';\n  flex: 1 1 calc(33.33% - 20px);\n}\n\n.collapse-arrow {\n  font-size: 14px;\n  user-select: none;\n}\n\n.nested-permission-group{\n  margin-top: 20px;\n  background: #F4F6FD;\n  padding: 22px;\n}\n\n.nested-permission-group-title label{\n  position: inherit !important;\n  color: black;\n  font-size: 16px;\n  font-weight: 700;\n  font-size: 18px;\n  margin-left: 5px;\n  background: transparent;\n}\n\n.cms-permission-label {\n  position: inherit !important;\n  margin-left: 5px;\n  color: black;\n  background-color: transparent;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.subcategory-label,\n.category-label {\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.subcategory-container {\n  margin-left: 20px;\n  margin-top: 10px;\n}\n\n.subcategory-item {\n  margin-bottom: 10px;\n}\n\n@media screen and (max-width: 768px) {\n  .nested-permission-group{\n    padding: 10px;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
